// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"_3awN7","button":"_3DmG6"};